import ChatNew from './ChatNew'

export default ChatNew
// eslint-disable-next-line import/export
export * from './ChatNew'
